import { render } from "./CreateUserModal.vue?vue&type=template&id=5bdbcb5c&scoped=true"
import script from "./CreateUserModal.vue?vue&type=script&lang=js"
export * from "./CreateUserModal.vue?vue&type=script&lang=js"

import "./CreateUserModal.vue?vue&type=style&index=0&id=5bdbcb5c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bdbcb5c"]])

export default __exports__